import { useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import HeroSection from "@/components/HeroSection";
import LazyOnScroll from "@/components/LazyOnScroll";

// Lazy load below-the-fold components to reduce initial JS bundle
const BalansScorekaart = lazy(() => import("@/components/BalansScorekaart"));
const MaatregelenMatrix = lazy(() => import("@/components/MaatregelenMatrix"));
const PetitieCTA = lazy(() => import("@/components/PetitieCTA"));
const SiteFooter = lazy(() => import("@/components/SiteFooter"));

const Index = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [hash]);
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main>
        <HeroSection />
        <LazyOnScroll rootMargin="50px">
          <Suspense fallback={null}>
            <BalansScorekaart />
          </Suspense>
        </LazyOnScroll>
        <LazyOnScroll rootMargin="50px">
          <Suspense fallback={null}>
            <MaatregelenMatrix />
          </Suspense>
        </LazyOnScroll>
        <LazyOnScroll rootMargin="50px">
          <Suspense fallback={null}>
            <PetitieCTA />
          </Suspense>
        </LazyOnScroll>
      </main>
      <LazyOnScroll rootMargin="50px">
        <Suspense fallback={null}>
          <SiteFooter />
        </Suspense>
      </LazyOnScroll>
    </div>
  );
};

export default Index;
